<div class="controllable-buttons">
  @for (controllableItem of controllableItemList(); track controllableItem; let idx = $index) {
    @if (canShowItem(controllableItem)) {
      <div
        [class.pointer-events-auto]="vypnoutSracku()"
        class="wrapper"
        [class]="controllableItem.data?.type"
        [class.one-item]="isOneItemWrapper(controllableItem)"
        [class.one-column]="isOneColumnWrapper(controllableItem)"
        [ngStyle]="{
          '--custom-rgb': convertRgbaToRgb(1),
          '--custom-rgba': navigationGeodataObject().qrCategoryColor,
          '--custom-rgba-saturated': convertRgbaToRgb(0.8),
          '--automatic-text-color': getTextColorBasedOnBg(navigationGeodataObject().qrCategoryColor),
        }"
      >
        @if (isMonitorType(controllableItem.data?.type)) {
          <div
            cueFoldable
            [itemIdx]="idx"
            (heightValueChanged)="updateItemHeight(idx, $event)"
            class="section section--monitor"
          >
            <div class="open-detail-area" (click)="requestOpenPoiDetail.emit()"></div>
            @if (canBeFolded(idx)) {
              <cue-icon [icon]="ICONS.cueArrowUp" (click)="onToggleClicked($event, idx)" class="toggle-button" />
            }
            @if (
              canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.ObjectLabel) &&
              (controllableItem.data.label | cmLocalizedString)
            ) {
              <h2 class="title">{{ controllableItem.data.label | cmLocalizedString }}</h2>
            }
            <!--      JEDNOTLIVE PRVKY-->
            <div class="content">
              @for (item of controllableItem.data.item; track item) {
                @if (item.iconUrl || item.value || item.label) {
                  <div
                    class="item"
                    [class.has-color]="
                      canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Color) && item.color
                    "
                  >
                    <div class="item__icon-wrapper">
                      @if (
                        canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Icon) && item.iconUrl
                      ) {
                        <cue-icon
                          [icon]="item.iconUrl"
                          [customIconClass]="'item__icon'"
                          [ngStyle]="{
                            'background-color':
                              canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Color) &&
                              item.color
                                ? item.color
                                : 'none',
                            '--automatic-icon-color': getTextColorBasedOnBg(item.color),
                          }"
                        />
                      } @else if (
                        canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Color) && item.color
                      ) {
                        <span
                          class="color-icon"
                          [ngStyle]="{
                            'background-color': item.color,
                          }"
                        ></span>
                      }
                    </div>
                    @if (canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value) && item.value) {
                      <span class="item__value">{{ item.value | cmLocalizedString }}</span>
                    }
                    @if (canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Unit) && item.unit) {
                      <span class="item__unit">{{ item.unit | cmLocalizedString }}</span>
                    }
                    @if (canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Label) && item.label) {
                      <span class="item__label">{{ item.label | cmLocalizedString }}</span>
                    }
                  </div>
                }
              }
            </div>
          </div>
        } @else if (isControlType(controllableItem.data?.type)) {
          <div
            cueFoldable
            [itemIdx]="idx"
            (heightValueChanged)="updateItemHeight(idx, $event)"
            class="section section--control"
          >
            <div class="open-detail-area" (click)="requestOpenPoiDetail.emit()"></div>
            @if (canBeFolded(idx)) {
              <cue-icon [icon]="ICONS.cueArrowUp" (click)="onToggleClicked($event, idx)" class="toggle-button" />
            }
            @if (
              canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Label) &&
              (controllableItem.data.label | cmLocalizedString)
            ) {
              <h2
                class="title"
                [class.no-spacing]="!canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Control)"
              >
                {{ controllableItem.data.label | cmLocalizedString }}
              </h2>
            }

            @if (canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Control)) {
              @if (
                (controllableItem.data.message.text | cmLocalizedString) &&
                controllableItem.data.message?.type != messageTypeEnum.Nothing
              ) {
                <div class="message {{ controllableItem.data.message.type }}">
                  @if (controllableItem.data.message.iconUrl || controllableItem.data.message.type) {
                    <cue-icon
                      [icon]="controllableItem.data.message.iconUrl"
                      [customIconClass]="'message-icon'"
                      [icon]="getDefaultIconAccordingStatus(controllableItem.data.message.type)"
                    />
                  }
                  {{ controllableItem.data.message.text | cmLocalizedString }}
                </div>
              }

              <div class="content">
                @for (groupItem of controllableItem.data?.group; track groupItem) {
                  <div class="group">
                    <!--      GROUPA PRO OVLADACI PRVKY-->
                    @if (groupItem.label) {
                      <h3 class="group-title">{{ groupItem.label | cmLocalizedString }}</h3>
                    }

                    @if (
                      (groupItem.message.text | cmLocalizedString) && groupItem.message?.type != messageTypeEnum.Nothing
                    ) {
                      <div class="message {{ groupItem.message.type }}">
                        @if (groupItem.message.iconUrl || groupItem.message.type) {
                          <cue-icon
                            [icon]="groupItem.message.iconUrl ?? getDefaultIconAccordingStatus(groupItem.message?.type)"
                            [customIconClass]="'message-icon'"
                          />
                        }

                        {{ groupItem.message.text | cmLocalizedString }}
                      </div>
                    }
                    <!--      JEDNOTLIVE PRVKY-->
                    <div class="group-items">
                      @for (item of groupItem.item; track item) {
                        @if (item.type === 'pushButton') {
                          <button
                            cue-button
                            variant="control"
                            [disabled]="item.state !== 'enabled'"
                            class="{{ item.indication }}"
                            [class.with-icon]="item.iconUrl"
                            [class.icon-only]="!item.label && !item.value && !item.unit"
                            (click)="performAction(item, controllableItem.objectId, $event)"
                          >
                            @if (item.iconUrl) {
                              <cue-icon [icon]="item.iconUrl" [customIconClass]="'icon'" />
                            }
                            @if (item.label || item.value || item.unit) {
                              <span class="label-and-value">
                                @if (item.label) {
                                  <span class="label">{{ item.label | cmLocalizedString }}</span>
                                }
                                @if (item.value || item.unit) {
                                  <span class="value-and-unit">
                                    @if (item.value) {
                                      <span class="value">{{ item.value | cmLocalizedString }} </span>
                                    }
                                    @if (item.unit) {
                                      <span class="unit">{{ item.unit | cmLocalizedString }}</span>
                                    }
                                  </span>
                                }
                              </span>
                            }
                          </button>
                        }
                        @if (item.type === 'hidden') {
                          <div class="hidden-btn"></div>
                        } @else if (item.type === 'repeatButton') {
                          <button
                            cue-button
                            (mouseleave)="repeatButtonEnd(item, $event)"
                            (mousedown)="repeatButtonStart(item, controllableItem.objectId, $event)"
                            (mouseup)="repeatButtonEnd(item, $event)"
                            variant="control"
                            [disabled]="item.state !== 'enabled'"
                            class="{{ item.indication }} repeat"
                            [class.with-icon]="item.iconUrl"
                          >
                            @if (item.iconUrl) {
                              <cue-icon [icon]="item.iconUrl" [customIconClass]="'icon'" />
                            }
                            @if (item.label || item.value || item.unit) {
                              <span class="label-and-value">
                                @if (item.label) {
                                  <span class="label">{{ item.label | cmLocalizedString }}</span>
                                }
                                @if (item.value || item.unit) {
                                  <span class="value-and-unit">
                                    @if (item.value) {
                                      <span class="value">{{ item.value | cmLocalizedString }} </span>
                                    }
                                    @if (item.unit) {
                                      <span class="unit">{{ item.unit | cmLocalizedString }}</span>
                                    }
                                  </span>
                                }
                              </span>
                            }
                          </button>
                        } @else if (item.type === 'value') {
                          <div class="value-type">
                            @if (item.label) {
                              <span class="label">{{ item.label | cmLocalizedString }}</span>
                            }
                            <span class="value">
                              @if (item.value) {
                                <span>{{ item.value | cmLocalizedString }}</span>
                              }
                              @if (item.unit) {
                                <span>{{ item.unit | cmLocalizedString }}</span>
                              }
                            </span>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        } @else if (isValueInputType(controllableItem.data?.type)) {
          <div
            cueFoldable
            [itemIdx]="idx"
            (heightValueChanged)="updateItemHeight(idx, $event)"
            class="section section--value-input"
          >
            <div class="open-detail-area" (click)="requestOpenPoiDetail.emit()"></div>
            @if (canBeFolded(idx)) {
              <cue-icon [icon]="ICONS.cueArrowUp" (click)="onToggleClicked($event, idx)" class="toggle-button" />
            }

            @if (canShowValueInputObjectLabel(controllableItem)) {
              <h2 class="title">{{ controllableItem.data.label | cmLocalizedString }}</h2>
            }

            <div class="content">
              @for (item of controllableItem.data.item ?? []; track item.id) {
                @if (hasValueInputContent(item)) {
                  <div
                    class="value-input-item"
                    [class.value-input-item--with-arrows]="isLongNumberInputType(controllableItem.data?.type)"
                  >
                    <div class="value-input-item__main">
                      @if (
                        canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Label) && item.label
                      ) {
                        <span class="value-input-item__label">{{ item.label | cmLocalizedString }}</span>
                      }

                      <div
                        class="value-input-item__value-row"
                        [class.value-input-item__value-row--slider]="isSliderType(controllableItem.data?.type)"
                      >
                        @if (
                          isSliderType(controllableItem.data?.type) &&
                          canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value)
                        ) {
                          <kendo-slider
                            class="value-input-item__slider"
                            [min]="item.minimum ?? 0"
                            [max]="item.maximum ?? 100"
                            [smallStep]="item.step ?? 1"
                            [showButtons]="true"
                            [value]="getSliderValue(item)"
                            (click)="stopEditableInputEvent($event)"
                            (valueChange)="onSliderValueChanged(controllableItem.objectId, item.id, $event)"
                          ></kendo-slider>
                        } @else if (
                          isTimeInputType(controllableItem.data?.type) &&
                          canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value)
                        ) {
                          <kendo-timepicker
                            class="value-input-item__time-picker"
                            [format]="'HH:mm'"
                            [steps]="{ hour: 0, minute: 1 }"
                            [value]="getTimePickerValue(item)"
                            (click)="stopEditableInputEvent($event)"
                            (valueChange)="onTimePickerValueChanged(controllableItem.objectId, item.id, $event)"
                          ></kendo-timepicker>
                        } @else if (
                          isLongNumberInputType(controllableItem.data?.type) &&
                          canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value)
                        ) {
                          <kendo-numerictextbox
                            class="value-input-item__number-input"
                            [min]="item.minimum"
                            [max]="item.maximum"
                            [step]="item.step ?? 1"
                            [value]="getInputValue(item)"
                            (click)="stopEditableInputEvent($event)"
                            (valueChange)="onLongNumberValueChanged(controllableItem.objectId, item.id, $event)"
                          ></kendo-numerictextbox>
                        }
                        @if (
                          ((isSliderType(controllableItem.data?.type) ||
                            !isValueInputType(controllableItem.data?.type)) &&
                            canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value) &&
                            hasInputValue(item)) ||
                          (!isTimeInputType(controllableItem.data?.type) &&
                            canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Unit) &&
                            item.unit)
                        ) {
                          <div class="value-input-item-text">
                            @if (
                              (isSliderType(controllableItem.data?.type) ||
                                !isValueInputType(controllableItem.data?.type)) &&
                              canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value) &&
                              hasInputValue(item)
                            ) {
                              <span class="value-input-item__value">{{ getInputValue(item) }}</span>
                            }
                            @if (
                              !isTimeInputType(controllableItem.data?.type) &&
                              canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Unit) &&
                              item.unit
                            ) {
                              <span class="value-input-item__unit">{{ item.unit | cmLocalizedString }}</span>
                            }
                          </div>
                        }
                      </div>

                      @if (isSliderType(controllableItem.data?.type) && hasInputLimits(item)) {
                        <span class="value-input-item__limits">{{ getInputLimitsText(item) }}</span>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        } @else if (
          isIndicatorType(controllableItem.data?.type) &&
          (canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Color) ||
            canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value) ||
            canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Label))
        ) {
          <div class="section section--indicator">
            <div class="open-detail-area" (click)="requestOpenPoiDetail.emit()"></div>
            <!--      JEDNOTLIVE PRVKY-->
            <div class="content">
              <div
                class="item"
                [class.has-value]="
                  canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value) &&
                  controllableItem.data.value
                "
                [class.has-icon]="
                  canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Icon) &&
                  controllableItem.data.iconUrl
                "
                [class.has-label]="
                  canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Label) &&
                  controllableItem.data.label
                "
                [class.has-color]="
                  canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Color) &&
                  controllableItem.data.color
                "
                [ngStyle]="{
                  'background-color': canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Color)
                    ? controllableItem.data?.color
                    : 'none',
                  color: getTextColorIfAvailable(controllableItem),
                }"
              >
                @if (
                  canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Icon) &&
                  controllableItem.data.iconUrl &&
                  (!(
                    canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Label) &&
                    controllableItem.data.label
                  ) ||
                    (canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Label) &&
                      controllableItem.data.label &&
                      !(
                        canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value) &&
                        controllableItem.data.value
                      )))
                ) {
                  <cue-icon [icon]="controllableItem.data.iconUrl" [customIconClass]="'icon'" />
                }
                @if (canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value)) {
                  <span class="item__value">{{ controllableItem.data?.value | cmLocalizedString }}</span>
                }
              </div>

              @if (
                canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Label) &&
                controllableItem.data.label
              ) {
                @if (
                  canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Icon) &&
                  controllableItem.data.iconUrl &&
                  canShowHideableItemProperty(controllableItem, showInMapOrDetailModeEnum.Value) &&
                  controllableItem.data.value
                ) {
                  <cue-icon [icon]="controllableItem.data.iconUrl" [customIconClass]="'icon'" />
                }
                <span class="label">{{ controllableItem.data.label | cmLocalizedString }}</span>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>
